import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Paper from '@base/Paper/Paper';
import H2 from '@base/H2/H2';
import { mediaQuery, Spacings } from '@styles/index';
import { getCatalogueDetailsHomeTags, goBack } from '@utils/breadcrumbs';
import Breadcrumbs from '@cont/CatalogueItemDetails/BreadCrumbs';
import useTopology from '@api/hooks/topology/useTopology';

const StyledPaper = styled(Paper)`
  grid-column: span 24;
  display: flex;
  flex-direction: column;
  ${mediaQuery.uptoMobile} {
    box-shadow: none;
    background-color: var(--color-base-0);
    padding: ${Spacings.SPACING_6B} 0;
  }
`;

const StyBreadCrumbs = styled(Breadcrumbs)`
  margin-bottom: ${Spacings.SPACING_4B};
`;

const StyH3 = styled(H2)`
  color: var(--color-text-primary);
  line-height: 150%;
`;

const TopBlock = ({ goalUID, className, onBackClick }) => {
  const { topology: goalInfo } = useTopology(goalUID);
  return (
    <StyledPaper
      className={className}
      gridColumn="span 18"
      padding={`${Spacings.SPACING_8B} ${Spacings.SPACING_12B}`}
    >
      <StyBreadCrumbs
        goalData={goalInfo}
        getTags={getCatalogueDetailsHomeTags}
        onBackClick={onBackClick}
      />
      <StyH3>Doubt solution</StyH3>
    </StyledPaper>
  );
};

export default TopBlock;

TopBlock.propTypes = {
  className: PropTypes.string,
  goalUID: PropTypes.string.isRequired,
  onBackClick: PropTypes.func
};

TopBlock.defaultProps = {
  className: '',
  onBackClick: goBack
};
